import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { InvoicesList } from '../../components/InvoicesList';

const Container = styled.div`
  ${tw`w-full max-w-full min-w-0 max-w-screen-xl mx-auto p-4 md:p-6 box-border`}
`;

const Title = styled.h1`
  ${tw`text-2xl md:text-3xl font-black text-text-primary mb-8`}
`;

export default function InvoicesByRefundStatusPage() {
  return (
    <Container>
      <Title>Refund Invoices</Title>
      <InvoicesList />
    </Container>
  );
}
